import { render, staticRenderFns } from "./SearchHistoryItem.vue?vue&type=template&id=478ba2ad&scoped=true&"
import script from "./SearchHistoryItem.vue?vue&type=script&lang=ts&"
export * from "./SearchHistoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHistoryItem.vue?vue&type=style&index=0&id=478ba2ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ba2ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478ba2ad')) {
      api.createRecord('478ba2ad', component.options)
    } else {
      api.reload('478ba2ad', component.options)
    }
    module.hot.accept("./SearchHistoryItem.vue?vue&type=template&id=478ba2ad&scoped=true&", function () {
      api.rerender('478ba2ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/items/SearchHistoryItem.vue"
export default component.exports